import gql from 'graphql-tag';

export const RESEND_FAILED_INVITE_MUTATION = gql`
  mutation ResendFailedInviteMutation($memberId: Int!, $programId: Int!, $resourceId: Int, $source: String, $userId: String) {
    success: resendFailedInvite(memberId: $memberId, programId: $programId, resourceId: $resourceId, source: $source, userId: $userId)
  }
`;
